// Packages
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import SummaryForm from "../components/SummaryForm";
import Footer from "../components/Footer";
import OrderSummary from "../components/OrderSummary";

import { setFieldColors } from "../actions/checkoutStore";

export default function StepsTemplate(props) {
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const previewMode = queryParams.get("preview_mode") || "false";

  const {
    information,
    shipping,
    billing,
    payment,
    urls,
    system_fields,
    colors,
    analytics_data,
    summary,
  } = useSelector((state) => state.checkoutStore);

  const [fontLoaded, setFontLoaded] = useState(false);
  function updateTheme(theme) {
    const colorMode = theme || (colors.is_dark_mode ? "dark" : "light");
    document.querySelector("html").setAttribute("data-bs-theme", colorMode);

    // override bootstrap default color
    if (colors.background_color) {
      document.body.style.backgroundColor = colors.background_color;
    } else {
      document.body.style.backgroundColor = "";
    }
    dispatch(setFieldColors("is_dark_mode", colorMode === "dark"));
    localStorage.setItem("is_dark_mode", colorMode === "dark");
  }
  useEffect(() => {
    const storedDarkMode = localStorage.getItem("is_dark_mode");
    if (storedDarkMode !== null) {
      updateTheme(storedDarkMode === "true" ? "dark" : "light");
    } else {
      updateTheme();
    }

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    mediaQuery.addEventListener("change", updateTheme());

    return () => {
      mediaQuery.removeEventListener("change", updateTheme());
    };
  }, []);

  useEffect(() => {
    // Function to dynamically load a Google Font
    const loadGoogleFont = async (fontName) => {
      try {
        const fontUrl = `https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, "+")}&display=swap`;

        const linkElement = document.createElement("link");
        linkElement.href = fontUrl;
        linkElement.rel = "stylesheet";
        document.head.appendChild(linkElement);

        // Set the state to true once the font is loaded
        linkElement.onload = () => setFontLoaded(true);
      } catch (error) {
        console.error("Error loading Google Font:", error);
      }
    };

    if (information.font != null)
      loadGoogleFont(information.font.split(",")[0].trim());
  }, [information.font]);

  return (
    <div
      className="mainDiv"
      style={{
        backgroundColor: colors.background_color,
        color: colors.text_color,
        pointerEvents: previewMode === "true" ? "none" : "",
        fontFamily: fontLoaded ? information.font : "",
      }}
    >
      <div className="">
        <div
          className={`${
            !information.is_mobile ? "d-flex" : ""
          } app-div g-0 justify-content-between container-lg container-max-width`}
          style={{
            gap: "33px",
          }}
        >
          <div
            className={
              !information.is_mobile ? "leftDiv d-flex flex-column" : "leftDiv"
            }
          >
            <h1
              className="storeTitle pt-4 "
              style={{
                paddingRight: information.is_mobile ? "0px" : "33px",
              }}
            >
              <a
                className="underline-link"
                href={urls.storefront}
                style={{
                  color: colors.main_color,
                }}
              >
                {information.store_logo ? (
                  <img
                    src={information.store_logo}
                    title={information.store_name}
                  />
                ) : (
                  information.store_name
                )}
              </a>
            </h1>
            <div
              className=""
              style={{
                flexGrow: "1",
                paddingRight: information.is_mobile ? "0px" : "33px",
              }}
            >
              <div
                className={` ${
                  information.is_mobile && information.open_summary
                    ? "pb-2 px-3 pe-lg-0 ps-lg-4"
                    : "px-3 pe-lg-0 ps-lg-4"
                }`}
              >
                {props.children}
              </div>
            </div>
            {!information.is_mobile && <Footer />}
          </div>
          {!information.is_mobile ? (
            <div
              className="rightDiv me-2"
              style={{
                minWidth: "400px",
              }}
            >
              <div className="rightBackground"></div>
              <SummaryForm
                is_mobile={information.is_mobile}
                navigationFooter={props.navigationFooter}
              />
            </div>
          ) : (
            <div className="px-3 pb-4">
              <OrderSummary />
              {props.navigationFooter}
            </div>
          )}
        </div>
      </div>
      {information.is_mobile && <Footer />}
    </div>
  );
}
